import React, {Fragment, memo, useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import H5Player from 'react-h5-audio-player';

import {
	// audioplayerStateSelector,
	featureSelectPreselectSelector,
} from '../../store/selectors';
import {audioplayerPause, audioplayerStart} from '../../store/actions';


function AudioPlayer({}) {
	const dispatch = useDispatch();
	// const apState = useSelector(audioplayerStateSelector);

	// const ref = /** @type {React.LegacyRef<H5Player>} */(useRef());

	const feature = useSelector(featureSelectPreselectSelector);
	const audioSrc = feature?.properties?.audio?.url;

	useEffect(
		() => {
			dispatch(audioplayerPause());
		},
		[audioSrc, dispatch],
	);

	const onPlay = useCallback(
		() => dispatch(audioplayerStart()),
		[dispatch],
	);

	const onPause = useCallback(
		() => dispatch(audioplayerPause()),
		[dispatch],
	);

	return (
		<div className={`stade-widget stade-widget__audioplayer`}>
			<H5Player
				src={audioSrc}
				// ref={ref}
				onPlay={onPlay}
				onPause={onPause}
				onEnded={onPause}
				autoPlay={false}
				autoPlayAfterSrcChange={false}
				layout="stacked-reverse"
				customVolumeControls={[]}
				customAdditionalControls={[]}
				customProgressBarSection={['CURRENT_TIME', 'PROGRESS_BAR', 'CURRENT_LEFT_TIME']}
				progressJumpSteps={{backward: 30000, forward: 30000}}
				customIcons={CUSTOM_ICONS}
			/>
		</div>
	);
}

export default memo(AudioPlayer);

const CUSTOM_ICONS = {
	play: (
		<svg
			viewBox="0 0 60 60"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<defs>
				<path
					id="play-path-1"
					d="M30,2 C45.463973,2 58,14.536027 58,30 C58,45.463973 45.463973,58 30,58 C14.536027,58 2,45.463973 2,30 C2,14.536027 14.536027,2 30,2 Z M30,4 C15.6405965,4 4,15.6405965 4,30 C4,44.3594035 15.6405965,56 30,56 C44.3594035,56 56,44.3594035 56,30 C56,15.6405965 44.3594035,4 30,4 Z M25.4013878,18.2696924 C25.7962378,18.2696924 26.1822532,18.3865684 26.5107882,18.6055918 L26.5107882,18.6055918 L41.7080126,28.7370747 C42.62707,29.3497796 42.8754177,30.5915183 42.2627128,31.5105757 C42.1162431,31.7302802 41.9277171,31.9188061 41.7080126,32.0652759 L41.7080126,32.0652759 L26.5107882,42.1967588 C25.5917308,42.8094637 24.3499921,42.5611159 23.7372872,41.6420586 C23.5182639,41.3135235 23.4013878,40.9275082 23.4013878,40.5326582 L23.4013878,40.5326582 L23.4013878,20.2696924 C23.4013878,19.1651229 24.2968183,18.2696924 25.4013878,18.2696924 Z"
				/>
			</defs>
			<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<path d="M30,2 C14.536027,2 2,14.536027 2,30 C2,45.463973 14.536027,58 30,58 C45.463973,58 58,45.463973 58,30 C58,14.536027 45.463973,2 30,2 Z" fill="#FFFFFF" fillRule="nonzero"></path>
				<mask id="play-mask-2" fill="white">
					<use xlinkHref="#play-path-1"></use>
				</mask>
				<use fill="#002856" fillRule="nonzero" xlinkHref="#play-path-1"></use>
				<g mask="url(#play-mask-2)" fill="#002856">
					<g>
						<rect x="0" y="0" width="60" height="60"></rect>
					</g>
				</g>
			</g>
		</svg>
	),
	pause: (
		<svg
			viewBox="0 0 60 60"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<defs>
				<path
					id="pause-path-1"
					d="M30,2 C45.463973,2 58,14.536027 58,30 C58,45.463973 45.463973,58 30,58 C14.536027,58 2,45.463973 2,30 C2,14.536027 14.536027,2 30,2 Z M30,4 C15.6405965,4 4,15.6405965 4,30 C4,44.3594035 15.6405965,56 30,56 C44.3594035,56 56,44.3594035 56,30 C56,15.6405965 44.3594035,4 30,4 Z M25.5,20 C26.0128358,20 26.4355072,20.3860402 26.4932723,20.8833789 L26.5,21 L26.5,40.5 C26.5,41.0128358 26.1139598,41.4355072 25.6166211,41.4932723 L25.5,41.5 L21,41.5 C20.4871642,41.5 20.0644928,41.1139598 20.0067277,40.6166211 L20,40.5 L20,21 C20,20.4871642 20.3860402,20.0644928 20.8833789,20.0067277 L21,20 L25.5,20 Z M39,20 C39.5128358,20 39.9355072,20.3860402 39.9932723,20.8833789 L40,21 L40,40.5 C40,41.0128358 39.6139598,41.4355072 39.1166211,41.4932723 L39,41.5 L34.5,41.5 C33.9871642,41.5 33.5644928,41.1139598 33.5067277,40.6166211 L33.5,40.5 L33.5,21 C33.5,20.4871642 33.8860402,20.0644928 34.3833789,20.0067277 L34.5,20 L39,20 Z"
				/>
			</defs>
			<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<path d="M30,2 C14.536027,2 2,14.536027 2,30 C2,45.463973 14.536027,58 30,58 C45.463973,58 58,45.463973 58,30 C58,14.536027 45.463973,2 30,2 Z" id="Path" fill="#FFFFFF" fillRule="nonzero"></path>
				<mask id="pause-mask-2" fill="white">
					<use xlinkHref="#pause-path-1"></use>
				</mask>
				<use id="Mask" fill="#002856" fillRule="nonzero" xlinkHref="#pause-path-1"></use>
				<g mask="url(#pause-mask-2)" fill="#002856">
					<g>
						<rect x="0" y="0" width="60" height="60"></rect>
					</g>
				</g>
			</g>
		</svg>
	),
	rewind: (
		<Fragment>
			<span className="stade-widget__audioplayer__jump-button">
				«
			</span>
			<span className="stade-widget__audioplayer__jump-time">
				30
			</span>
		</Fragment>
	),
	forward: (
		<Fragment>
			<span className="stade-widget__audioplayer__jump-time">
				30
			</span>
			<span className="stade-widget__audioplayer__jump-button">
				»
			</span>
		</Fragment>
	),
};
